import { AxiosStatic } from "axios";
import { OTPGenerateResponse, TwoFactorAuthMethod } from "../types";

const generateOtp =
  (serverURL: string, versionURLFragment: string, appAxios: AxiosStatic) =>
  async (
    email: string,
    mfaMethod?: TwoFactorAuthMethod
  ): Promise<OTPGenerateResponse> => {
    const response = await appAxios.post<OTPGenerateResponse>(
      `${serverURL}/auth${versionURLFragment}/otp/generate`,
      {
        email,
        mfaMethod,
      },
      {
        withCredentials: true,
      }
    );
    return response.data;
  };

export default generateOtp;
